import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import Select2 from "../../../../components/common/select/Select2";
import Input from "../../../../components/common/input/Input";
import Typeahead from "../../../../components/common/typeahead/Typeahead";
import DatePicker2 from "../../../../components/common/datepicker/DatePicker2";
import { Field } from "redux-form";
import { required, date } from "../../../../utils/forms/validators";
import styles from "./FilterBox.scss";

const dateVal = date("Please enter a valid Date.");

const CATEGORIES = [
  { id: 1, value: "Industry" },
  { id: 2, value: "Size" },
  { id: 3, value: "Date Created" }
];

class FilterBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      selectedCategory: -1
    };
    this.onChange = this.onChange.bind(this);
  }

  componentDidMount() {
    if (this.props.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: this.props.selected });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected !== this.state.selectedCategory) {
      this.setState({ selectedCategory: nextProps.selected });
    }
  }

  onChange(value) {
    this.setState({ selectedCategory: value });
  }

  renderLocation() {
    return (
      <Field
        name={`${this.props.inputName}.location`}
        placeholder="Criteria"
        component={Typeahead}
        onSearch={query => this.props.onSearchCities(query)}
        isLoading={this.props.isLoadingCities}
        options={this.props.cities}
        isAsync={true}
        minLength={3}
        allowNew={false}
        labelKey="description"
        valueKey="id"
        selected={this.props.selectedLocation}
        icon="map-marker"
      />
    );
  }

  renderIndustry() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.industry`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.industriesOptions}
      />
    );
  }

  renderCompanySize() {
    return (
      <Field
        validate={[required]}
        name={`${this.props.inputName}.company_size`}
        type="select"
        placeholder="Criteria"
        component={Select2}
        options={this.props.companySizesOptions}
      />
    );
  }

  renderDateCreated() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.signed_up_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.signed_up_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderNumberOfJobsPosted() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.jobs_from`}
            placeholder="From"
            component={Input}
            validate={required}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.jobs_to`}
            placeholder="To"
            component={Input}
            validate={required}
          />
        </Col>
      </div>
    );
  }

  renderNumberOfSows() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.sows_from`}
            placeholder="From"
            component={Input}
            validate={required}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.sows_to`}
            placeholder="To"
            component={Input}
            validate={required}
          />
        </Col>
      </div>
    );
  }

  renderLastLoginDate() {
    return (
      <div>
        <Col xs={12} md={6} className={styles.noPadLeft}>
          <Field
            name={`${this.props.inputName}.last_login_after`}
            placeholder="From"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
        <Col xs={12} md={6} className={styles.noPadHorizontal}>
          <Field
            name={`${this.props.inputName}.last_login_before`}
            placeholder="To"
            component={DatePicker2}
            validate={dateVal}
          />
        </Col>
      </div>
    );
  }

  renderCriteria() {
    switch (this.state.selectedCategory) {
      case 1:
        return this.renderIndustry();
      case 2:
        return this.renderCompanySize();
      case 3:
        return this.renderDateCreated();
      case 4:
        return this.renderLastLoginDate();
      case 5:
        return this.renderNumberOfJobsPosted();
      case 6:
        return this.renderNumberOfSows();
      case 7:
        return this.renderLocation();
      default:
        return null;
    }
  }

  render() {
    return (
      <Row>
        <Col xs={12} md={5}>
          <Field
            validate={required}
            name={this.props.name}
            type="select"
            placeholder="Category"
            component={Select2}
            options={CATEGORIES}
            onSelectChange={this.onChange}
          />
        </Col>
        <Col xs={12} md={7}>
          {this.renderCriteria()}
        </Col>
      </Row>
    );
  }
}

export default FilterBox;



// WEBPACK FOOTER //
// ./src/routes/admin/companies/components/FilterBox.js